import { useState } from "react";

export function CopyButton({
  text,
  className = "",
  label = "copy",
}: {
  text: string;
  className?: string;
  label?: string;
}) {
  const [done, setDone] = useState(false);
  return (
    <button
      type="button"
      className={`inline-flex h-4 w-4 items-center justify-center rounded-sm text-fg-faint hover:bg-bg-hover hover:text-fg ${className}`}
      title={done ? "copied" : label}
      aria-label={label}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        void navigator.clipboard?.writeText(text).then(() => {
          setDone(true);
          setTimeout(() => setDone(false), 1200);
        });
      }}
    >
      {done ? "✓" : "⧉"}
    </button>
  );
}
